import { WPDangerEvaluation } from "./WPDangerEvaluation";

export interface WPEvaluationMaster {
  // DB
  uid: number;
  departmentUID: number;
  contents: string;
  serialNo: number;
  material: string;
  isDeleted: boolean;
  entryDate: Date | string;
  modifyDate: Date | string;

  // Not DB
  isOuter: boolean; // 외부 여부 => 외부인 경우 부서명과 평가자는 'N/A' 로 표시한다
  serialMessage: string;
  revisionCount: number; // 개정 개수
  revisions: WPDangerEvaluation[]; // Deprecated 개정목록 
}

export const initializeEvaluataionMaster = (): WPEvaluationMaster => {
  return {
    // DB Value
    uid: 0,
    departmentUID: 0,
    contents: "", // 내용
    serialNo: 0, // 일련번호
    material: "", // 취급 물질
    isDeleted: false,
    entryDate: new Date(),
    modifyDate: new Date(),

    // Not DB
    isOuter: false, // 외부 여부 => 외부인 경우 부서명과 평가자는 'N/A' 로 표시한다
    serialMessage: "",
    revisionCount: 0,
    revisions: [] as WPDangerEvaluation[], // 작업 단계 목록
  };
};
export interface EvaluationListParams {
  page: number;
  rows: number;
  token: string;
  contents: string;
  departmentUID: number; // -1 은 전체
  range: number; // -1 전체, 0 - 내부, 1 - 외부
  startDate: Date | string | null;
  endDate: Date | string | null;
}

export const initializeEvaluationListParams = (): EvaluationListParams => {
  return {
    page: 1,
    rows: 30,
    token: "",
    contents: "",
    departmentUID: -1, // -1 은 전체
    range: -1, // -1 전체, 0 - 내부, 1 - 외부
    startDate: null,
    endDate: null,
  };
};

export const CategoryNames = [
  "일반작업",
  "화기작업",
  "밀페작업",
  "정전작업",
  "굴착작업",
  "방사선",
  "고소작업",
  "중장비",
];